// Which app shell a visit needs — decided in index.js BEFORE either shell is downloaded.
//
// Parents arrive from Facebook on phones; they must only pay for the public pages (landing,
// trial form, public forms), never for the ~2 MB staff office app. Staff (a stored token, or
// the login page) get the full app. The rules here mirror the order App.js itself uses, so
// the two never disagree about what a path shows.

export const PUBLIC_TITLE = 'Carmen Taekwondo Academy — Free trial class for kids in Carmen & Tubigon';

const STAFF_LOGIN_PATHS = ['/login', '/staff', '/staff-login'];

export function publicRouteFor(pathname) {
  const raw = pathname || '/';
  const p = raw.toLowerCase();
  if (p === '/trial/carmen') return { kind: 'trial', location: 'Carmen' };
  if (p === '/trial/tubigon') return { kind: 'trial', location: 'Tubigon' };
  if (p.startsWith('/form/')) return { kind: 'form', formId: raw.split('/form/')[1] };
  return { kind: 'landing' };
}

export function isStaffLoginPath(pathname) {
  return STAFF_LOGIN_PATHS.includes((pathname || '/').toLowerCase());
}

/** True when the full staff app should be loaded for this visit. */
export function shouldLoadStaffApp(pathname, token) {
  if (isStaffLoginPath(pathname)) return true;
  // Trial and public-form pages are public even for a logged-in staff member (App.js checks
  // them before auth), so they never need the staff bundle.
  if (publicRouteFor(pathname).kind !== 'landing') return false;
  return !!token;
}
